/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // STRAPI_API_KEY: "ba24fc91bba6a434c69cd2716156474695ad45b28ddba91f5ceae2757b0b040ead3a39b8157021041c1a558e5a139873eb5d52539eac0ecfd17807f976d3e8780d8e007b4a8f79b11fcc86da2874a0622934e62cb3102f7806d9262fbd3e5c04dc94b368b2048391e82b3a6a647ecb0f3d64a3c457ecffd1799bb93f4c177343",
  STRAPI_API_KEY:
    "875675655db445a4b3c30ac5aae41c793a9edf76a7b9ea3778d7456fd8a3c1859cfab70b38063b8cd1e9a7d5657bf5b02715c6196a6255298f9b9f00679c9f9372b6803de1bc2401e362ec12d773a294749fd2161d1c5f8fe9fb11ca7d173387da101fac71480f69d6713449b5e903d438bca48920cd01954fa998225af41faa",
  STRAPI_API_ADDRESS: "https://api.litbitfinance.app/api",
  GOOGLE_RECAPTCHA_SITE_KEY: "6LciascfAAAAANLOZFOtMdF8f4UyvHc1k7cPH1nT",
  API_ADDRESS: "https://api.beyondi.ninja",
  GOOGLE_API_KEY: "AIzaSyAh1HC6zrL-zBOl7W3dtv0hI7vxrhP6T70",
};
